Ext.define('SA.CrosstabExportConfig', {
    extend: 'SA.ExportConfig',

    resource: 'data/crosstab',
    excelOnly: true,

    async prepare() {
        var weight = 'respondent',
            locationSeries = this.model.getLocation(),
            {top: vertical, left: horizontal} = this.model.getAttributeArrays();

        this.params = {weight, locationSeries, vertical, horizontal};
        this.limitCheck = await SA.LimitCheck.getForCrosstab(this.params);
    }
});